import CloseIcon from "@mui/icons-material/Close";
import { IconButton, Typography } from "@mui/material";
import moment from "moment";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import { soapApiJson } from "../../../../redux/actions/api";
import {
  getClinicStocksWoLoader,
  getPetBillingByIdAllWoLoader,
  getServicesWoLoader,
  postClinicalNotesWoLoader,
  setApiInProgress,
} from "../../../../redux/reducers/clinicSlice";
import {
  hideLoader,
  showLoader,
  showLoaderText,
} from "../../../../redux/reducers/loaderSlice";
import {
  getCompliantSummaryByIdWoLoader,
  getPetsCompliantSummaryWoLoader,
} from "../../../../redux/reducers/petSlice";
import { showSnackBar } from "../../../../redux/reducers/snackSlice";
import { AppColors } from "../../../../util/AppColors";
import {
  fieldMap,
  inpatFieldMap,
  surFieldMap,
} from "../../../../util/arrayMap";
import { routeList, statusDrop } from "../../../../util/dropList";
import {
  consolidateShouldBeTrue,
  consolidateShouldBeTrueForOutpatient,
  getArryAsString,
  getInpatNotes,
  getOutpatientNotes,
  getRightSaluation,
  getTotalEstCostForWorkbook,
  processGroupedNotes,
  toObject,
} from "../../../../util/function";
import UpdateRemarks from "../../../CommonScreens/UpdateRemarks/UpdateRemarks";
import BodyMapView from "../../../CommonScreens/WorkBook/BodyMapView";
import DiagnosticsView from "../../../CommonScreens/WorkBook/DiagnosticsView";
import FileView from "../../../CommonScreens/WorkBook/FileView";
import FormsView from "../../../CommonScreens/WorkBook/FormsView";
import PrescriptionView from "../../../CommonScreens/WorkBook/PrescriptionView";
import PreventiveView from "../../../CommonScreens/WorkBook/PreventiveView";
import SoapNoteView from "../../../CommonScreens/WorkBook/SoapNoteView";
import TreatmentPlanView from "../../../CommonScreens/WorkBook/TreatmentPlanView";
import VitalsView from "../../../CommonScreens/WorkBook/VitalsView";
import InpatientTasks from "../InpatientTasks/InpatientTasks";
import BodyMap from "./BodyMap";
import Files from "./Files";
import PetDiagnostics from "./PetDiagnostics";
import PetForms from "./PetForms";
import PetProcedures from "./PetProcedures";
import PetTreatmentPlan from "./PetTreatmentPlan";
import PetVitals from "./PetVitals";
import SoapNotesNew from "./SoapNotesNew";
import WorkBookHistory from "./WorkBookHistory";

const initProced = { consumList: [], adminList: [], presList: [] };
const cardIcon = { width: 30, height: 30, color: AppColors.appPrimary };
const initOpenObj = { consum: true, admin: true, pres: true };
const tabList = [
  {
    name: "Clinical Workflow",
    list: ["Vitals", "SOAP Notes", "Diagnostics", "Procedures", ,],
  },
  { name: "Forms", list: ["Protocol Forms", "Consent Forms"] },
  { name: "Records", list: ["Body Map", "Files"] },
  { name: "Tasks", list: ["Tasks"] },
];

const PatientWorkbook = ({
  appointment,
  setScrollable,
  setSelectedTab,
  setSelectedBill,
  setEditBill,
}) => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("procedures");
  const [procedures, setProcedures] = useState([]);
  const [procedValues, setProcedValues] = useState(initProced);
  const [objOpen, setObjOpen] = useState(initOpenObj);
  const [warnModVsble, setWarnModVsble] = useState(false);
  const [finModVsble, setFinModVsble] = useState(false);
  const [summaryModVsble, setSummaryModVsble] = useState(false);
  const [diagList, setDiagList] = useState([]);
  const [remarksModVsble, setRemarksModVsble] = useState(false);
  const [isSumamryView, setIsSumamryView] = useState(false);
  const [selectedTabs, setSelectedTabs] = useState({
    main: "Clinical Workflow",
    subTab: "Vitals",
  });
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const lastSummary = useSelector((state) => state?.pet?.lastSummary?.data);
  const {
    services,
    clinicStocks,
    petBilling,
    details: clinicDet,
    apiInProgress,
  } = useSelector((state) => state?.clinic);
  const clinicVets = useSelector((state) => state?.vet?.vets?.vets);
  const appDet = reqDet?.appointment;
  const isAnyApiInProgress =
    apiInProgress?.soapGeneration ||
    apiInProgress?.clinicNotesPost ||
    apiInProgress?.clinicNotesPut ||
    apiInProgress?.consolidateSoap;
  const petDet = reqDet?.pet;
  const apnt = reqDet?.appointment ?? appointment?.appoinment;

  useEffect(() => {
    onApiCall();
    dispatch(getServicesWoLoader());
    dispatch(getClinicStocksWoLoader());
    // dispatch(getPetBillingByIdAllWoLoader({ petId: appDet?.petId }));
  }, []);

  useEffect(() => {
    const reqPrceds = [];
    const reqCons = [];
    const reqAdms = [];
    const reqPresList = [];
    const reqDiagList = [];
    reqDet?.diagnostics?.forEach((diag) => {
      const reqServ = services?.data?.find(
        (ser) => ser?.serviceId === diag?.serviceId,
      );
      const reqVnt = reqServ?.serviceVariants?.find(
        (vnt) => vnt?.variantId === diag?.variantId,
      );
      reqDiagList.push({ total: reqVnt?.servicePrice ?? 0 });
    });
    reqDet?.procedures?.forEach((prcd, i) => {
      const reqServ = services?.data?.find(
        (ser) => ser?.serviceId === prcd?.serviceId,
      );
      const vnts = getVarinatList(prcd?.serviceId);
      const reqVnt = vnts?.find(
        (vnt) =>
          vnt?.serviceId === prcd?.serviceId && vnt?.name === prcd?.serviceType,
      );
      const reqTaxPer = Number(
        reqServ?.taxApplicability?.toLowerCase() === "yes" ? reqServ?.tax : 0,
      );
      const reqTax = (Number(reqVnt?.serviceCharge ?? 0) / 100) * reqTaxPer;

      const reqObj = {
        service: {
          name: reqServ?.serviceName,
          value: reqServ?.serviceName,
          serviceId: reqServ?.serviceId,
          category: reqServ?.category,
          subCategory: reqServ?.subCategory,
          remarks: reqServ?.description,
          procedureId: prcd?.procedureId,
        },
        variant: {
          ...reqVnt,
          tax: reqTax ?? 0,
          serviceCharge: reqVnt?.serviceCharge + reqTax,
        },
        procedureId: prcd?.procedureId,
        i,
      };
      reqPrceds.push(reqObj);
      prcd?.procedureDetails?.forEach((det) => {
        const reqStock = clinicStocks?.data?.find(
          (stc) => stc?.stockId === det?.stockId,
        );
        const reqBatc = det?.batchId
          ? reqStock?.stockBatch?.find((bat) => bat?.batchId === det?.batchId)
          : reqStock?.stockBatch?.[0];
        let reqEstimatedCost = det?.estimatedCost;
        if (det?.type?.toLowerCase() === "consumables") {
          reqEstimatedCost =
            Number(reqBatc?.unitSellingPrice ?? 0) * Number(det?.quantity ?? 1);
        }
        if (det?.type?.toLowerCase() !== "consumables") {
          const reqPack = reqBatc?.packageUom?.match(/^(\d+)(.+)/);
          const priceRatio =
            Number(det?.dosage ?? reqPack?.[1] ?? 0) / Number(reqPack?.[1]);
          reqEstimatedCost =
            (Number(reqBatc?.unitSellingPrice) ?? 0) * Number(priceRatio ?? 0);
        }

        const comObj = {
          name: det?.name ?? reqStock?.productName ?? det?.procedureName ?? "",
          procedureName: det?.procedureName,
          stockId: det?.stockId,
          batchId: det?.batchId,
          quantity: det?.quantity,
          detailId: det?.detailId,
          active: det?.active,
          status: det?.status?.length > 0 ? det?.status === "true" : null,
          statusDrop:
            det?.status?.length > 0
              ? det?.status === "true"
                ? statusDrop?.[0]
                : statusDrop?.[1]
              : null,
          reason: det?.remarks?.length > 0 ? det?.remarks : null,
          estCost: reqEstimatedCost,
          // estCost: det?.estimatedCost,
          delete: false,
          isEdit:
            det?.status === "true" || det?.status === "false" ? false : true,
          deleteable: true,
          serviceId: prcd?.serviceId,
          variantId: reqVnt?.variantId,
          assignToProcedure: {
            name: reqServ?.serviceName,
            serviceId: prcd?.serviceId,
            value: reqServ?.serviceName,
            variantId: reqVnt?.variantId,
          },
          linkToProcedure: reqServ?.serviceName,
        };
        if (det?.type === "Consumables") {
          reqCons.push(comObj);
        }
        if (det?.type === "Administered") {
          const reqAdmObj = {
            ...comObj,
            type: reqStock?.category,
            route: routeList?.find((rl) => rl?.name === det?.route),
            batchNumber: {
              name: reqBatc?.batchNo,
              value: reqBatc?.batchId,
              batchId: reqBatc?.batchId,
              salesUom: reqBatc?.salesUom,
            },
            batchId: det?.batchId,
            duration: "1",
            vaccineType: det?.route,
            dosage: det?.dosage,
          };
          reqAdms.push(reqAdmObj);
        }
      });
    });
    reqDet?.prescription?.[0]?.prescriptionDetails?.forEach((li, i) => {
      const reqObj = {
        ...li,
        detailId: li?.id,
        name: null,
        dosage: li?.dosage,
        duration: li?.duration,
        frequency:
          li?.morning || li?.afternoon || li?.night
            ? [
                li?.morning && "morning",
                li?.afternoon && "afternoon",
                li?.night && "night",
              ]?.filter(Boolean)
            : li?.frequencyDuration?.length > 0
              ? li?.frequencyDuration
              : null,
        customFrequency:
          !li?.morning &&
          !li?.afternoon &&
          !li?.night &&
          li?.frequencyDuration?.length > 0,
        meal: li?.meal,
        plName: li?.name,
        i,
        type: li?.type,
        stockId: li?.stockId,
        qty: li?.quantity,
        isEdit: false,
      };
      reqPresList.push(reqObj);
    });
    setProcedures(reqPrceds);
    setProcedValues({
      ...procedValues,
      consumList:
        reqCons?.length > 0 ? reqCons?.map((cl, i) => ({ ...cl, i })) : [],
      adminList:
        reqAdms?.length > 0 ? reqAdms?.map((al, i) => ({ ...al, i })) : [],
      presList:
        reqPresList?.length > 0
          ? reqPresList?.map((pl, i) => ({ ...pl, i }))
          : [],
    });
    setDiagList(reqDiagList);
  }, [reqDet?.procedures, reqDet?.prescription]);

  // useEffect(() => {
  //   const reqPayment = petBilling?.data?.find(
  //     (pl) => pl?.appointmentId === appDet?.appointmentId
  //   );
  //   if (
  //     reqPayment?.paymentDetails?.filter((pd) => pd?.type === "diagnostics")
  //       ?.length > 0
  //   ) {
  //     const reqDiagList = reqPayment?.paymentDetails
  //       ?.filter((pd) => pd?.type === "diagnostics")
  //       ?.map((dl) => ({ total: dl?.total }));
  //     setDiagList(reqDiagList);
  //   }
  // }, [petBilling]);

  const onApiCall = () => {
    dispatch(getPetsCompliantSummaryWoLoader(appDet?.appointmentId));
  };

  const handleActive = (tab) => {
    setActiveTab(tab);
    if (tab === "procedures") onApiCall();
    setObjOpen({ ...objOpen, [tab]: true });
  };

  const getVarinatList = (serId) => {
    if (!serId) return [];
    const reqList = services?.data
      ?.find((ser) => ser?.serviceId === serId)
      ?.serviceVariants?.map((vnt) => ({
        name: vnt?.variantName,
        variantId: vnt?.variantId,
        servicePrice: vnt?.servicePrice,
        value: vnt?.variantName,
        serviceCharge: vnt?.serviceCharge,
        variantNumber: vnt?.variantNumber,
        serviceId: serId,
      }));
    return reqList ?? [];
  };

  const handleObjOpen = (name, value) => {
    setObjOpen({ ...objOpen, [name]: value });
  };

  const handleFinalize = async () => {
    // if (reqDet?.procedures?.length > 0) {
    //   const reqList = [];
    //   reqDet?.procedures?.forEach((li) => {
    //     // Number(
    //     //   getTotalEstimatedCost(
    //     //     li?.procedureDetails ?? [],
    //     //     li?.serviceCharge ?? 0
    //     //   )
    //     // ) ?? 0;
    //     const resServ = services?.data?.find(
    //       (ser) => ser?.serviceId === li?.serviceId
    //     );
    //     const reqVar = resServ?.serviceVariants?.find(
    //       (vnt) => vnt?.variantName === li?.serviceType
    //     );
    //     let tax = 0;
    //     let total = reqVar?.serviceCharge ?? li?.serviceCharge ?? 0;
    //     if (resServ?.taxApplicability?.toLowerCase() === "yes") {
    //       tax +=
    //         resServ?.taxApplicability?.toLowerCase() === "yes"
    //           ? (Number(reqVar?.serviceCharge ?? 0) / 100) *
    //             Number(resServ?.tax ?? 0)
    //           : 0;
    //       total += tax;
    //     }
    //     const data = {
    //       name: `${li?.procedureName} (${reqVar?.variantName})`,
    //       total,
    //       mrpPrice: reqVar?.serviceCharge ?? li?.serviceCharge ?? 0,
    //       price: reqVar?.serviceCharge ?? li?.serviceCharge ?? 0,
    //       tax,
    //       serviceId: li?.serviceId,
    //       variantNumber: reqVar?.variantNumber ?? "",
    //       variantId: reqVar?.variantId ?? null,
    //       patientWorkbook: true,
    //       procedureId: li?.procedureId,
    //       mainProcedure: true,
    //       quantity: 1,
    //     };
    //     reqList.push(data);
    //     if (
    //       li?.procedureDetails?.filter((det) => det?.status === "true")
    //         ?.length > 0
    //     ) {
    //       const newList = li?.procedureDetails?.filter(
    //         (det) => det?.status === "true"
    //       );
    //       newList?.forEach((itm) => {
    //         const reqStock = clinicStocks?.data?.find(
    //           (stc) => stc?.stockId === itm?.stockId
    //         );
    //         if (reqStock?.autoConsumed) return;
    //         const reqBat =
    //           reqStock?.stockBatch?.find(
    //             (bat) => bat?.batchId === itm?.batchId
    //           ) ?? null;
    //         const reqUnitPrice =
    //           reqBat?.unitSellingPrice ??
    //           reqStock?.stockBatch?.[0]?.unitSellingPrice ??
    //           0;
    //         const taxPerent =
    //           resServ?.taxApplicability?.toLowerCase() === "yes"
    //             ? Number(reqBat?.cgst ?? 0) + Number(reqBat?.sgst ?? 0)
    //             : 0;
    //         const reqPercent = 100 + Number(taxPerent);
    //         const unitPrice = Number(reqUnitPrice) / (reqPercent / 100);
    //         const priceAfterDiscount = Number(unitPrice);
    //         const prdTaxValue = (taxPerent / 100) * Number(priceAfterDiscount);
    //         const reqData = {
    //           name: itm?.procedureName,
    //           procedureId: li?.procedureId,
    //           patientWorkbook: true,
    //           mainProcedure: false,
    //           stockId: itm?.stockId,
    //           batchId: itm?.batchId,
    //           tax:
    //             Number(
    //               itm?.type === "Administered"
    //                 ? Number(itm?.dosage ?? 1)
    //                 : itm?.quantity
    //             ) * Number(prdTaxValue),
    //           total: itm?.estimatedCost,
    //           mrpPrice: reqVar?.serviceCharge ?? li?.serviceCharge ?? 0,
    //           price: reqVar?.serviceCharge ?? li?.serviceCharge ?? 0,
    //           // serviceId: li?.serviceId,
    //           quantity:
    //             itm?.type === "Administered"
    //               ? Number(itm?.dosage ?? 1)
    //               : itm?.quantity,
    //           type: itm?.type,
    //         };
    //         reqList.push(reqData);
    //       });
    //     }
    //   });
    //   if (reqList?.length > 0) {
    //     dispatch(
    //       addMultipleProcedureToBillingWoLoader({
    //         id: reqDet?.appointment?.appointmentId,
    //         list: reqList,
    //       })
    //     );
    //   }
    // }
  };

  const handlePaymentView = () => {
    if (reqDet?.paymentId && reqDet?.appointment?.appointmentId) {
      setSelectedBill({
        paymentId: reqDet?.paymentId,
        appointmentId: reqDet?.appointment?.appointmentId,
      });
      setEditBill(true);
      setSelectedTab("billing");
    }

    // const reqBill = petBilling?.data?.find(
    //   (bil) => bil?.appointmentId === appDet?.appointmentId,
    // );
    // if (reqBill) {
    // setEditBill(true);
    // setSelectedBill(reqBill);
    // setSelectedTab("billing");
    // }
  };

  const getApptDetailsForSoap = () => {
    const reqObj = {
      petName: petDet?.petName ?? apnt?.petName ?? "",
      species: petDet?.petType ?? "",
      breed: petDet?.breed ?? apnt?.breed ?? "",
      age: petDet?.dob ?? apnt?.dob ?? "",
      reproductiveStatus: petDet?.reproductiveStatus ?? "",
      gender: petDet?.gender ?? apnt?.gender ?? "",
      weight: petDet?.weight ?? apnt?.weight ?? "",
      appointmentDateTime: apnt?.appointmentdateTime ?? "",
      bloodGroup: petDet?.bloodGroup ?? apnt?.bloodGroup ?? "",
      temperament: petDet?.temperament ?? apnt?.temperament ?? "",
      color: petDet?.color ?? apnt?.color ?? "",
      rfid: petDet?.rfid ?? apnt?.rfid ?? "",
      veterinaryClinic: clinicDet?.name ?? "",
      username: petDet?.userName ?? apnt?.userName ?? "",
      vetName: apnt?.doctorName ?? "",
      appointmentId: apnt?.appointmentId ?? "",
    };
    return JSON.stringify(reqObj);
  };

  const handleViewSmmary = () => {
    if (!reqDet?.lastAppointmentId) return;
    dispatch(getCompliantSummaryByIdWoLoader(reqDet?.lastAppointmentId));
    setSummaryModVsble(true);
  };

  const onUpdateNote = ({
    Subjective = "",
    Objective = "",
    Assessment = "",
    Plan = "",
    Conclusion = "",
    DifferentialDiagnosis = "",
    KeyIssues = "",
    AbnormalFindings = "",
    CustomerInstructions = "",
    Reminders = "",
    sessionId = "",
    transcript = "",
    modificationCount = 0,
    blob = null,
    type = "outpatient",
    Summary = "",
    InstructionsStatus = "",
    RedFlags = "",
    OtherUpdates = "",
    Observation = "",
    consolidated = false,
    Protocols = "",
    ProgressNotes = "",
    PreSurgicalDocumentation = "",
    IntraSurgicalDocumentation = "",
    PostSurgicalDocumentation = "",
    OwnerCommunication = "",
    AdditionalDocumentation = "",
  }) => {
    const form = new FormData();
    form.append("subjective", Subjective);
    form.append("objective", Objective);
    form.append("assessment", Assessment);
    form.append("plan", Plan);
    form.append("conclusion", Conclusion);
    form.append("tag", DifferentialDiagnosis);
    form.append("keyIssues", KeyIssues);
    form.append("abnormalFindings", AbnormalFindings);
    form.append("customerInstructions", CustomerInstructions);
    form.append("reminders", Reminders);
    form.append("summary", Summary);
    form.append("instructionsStatus", InstructionsStatus);
    form.append("redFlags", RedFlags);
    form.append("otherUpdates", OtherUpdates);
    form.append("observation", Observation);
    form.append("sessionId", sessionId);
    form.append("modificationCount", modificationCount);
    form.append("type", type);
    form.append("consolidated", consolidated);
    form.append("preSurgicalDocumentation", PreSurgicalDocumentation);
    form.append("intraSurgicalDocumentation", IntraSurgicalDocumentation);
    form.append("postSurgicalDocumentation", PostSurgicalDocumentation);
    form.append("ownerCommunication", OwnerCommunication);
    form.append("additionalDocumentation", AdditionalDocumentation);
    if (consolidated) {
      form.append("protocols", Protocols);
      form.append("progressNotes", ProgressNotes);
    }
    if (transcript?.length > 0) form.append("transcript", transcript);
    dispatch(
      postClinicalNotesWoLoader({ appId: appDet?.appointmentId, form }),
    ).then((res) => {
      if (res?.payload) {
        dispatch(hideLoader());
        dispatch(showLoaderText(""));
        dispatch(getPetsCompliantSummaryWoLoader(appDet?.appointmentId));
        dispatch(
          showSnackBar({
            message: "Changes updated successfully!",
            type: "success",
          }),
        );
      }
      dispatch(hideLoader());
      dispatch(showLoaderText(""));
    });
  };

  const onConsolidateSoap = async (data, typ = "inpatient") => {
    try {
      dispatch(
        setApiInProgress({ apiType: "consolidateSoap", inProgress: true }),
      );
      dispatch(showLoader());
      dispatch(
        showLoaderText("Please wait while we consolidate the SOAP notes"),
      );
      const res = await soapApiJson.post("/consolidate-soap-notes", data);
      if (res?.status === 200) {
        dispatch(
          setApiInProgress({ apiType: "consolidateSoap", inProgress: false }),
        );
        if (res?.data?.consolidated_soap_note) {
          const reqObj = toObject(res?.data?.consolidated_soap_note);
          dispatch(showLoader());
          dispatch(
            showLoaderText("Please wait while we consolidate the SOAP notes"),
          );
          const apiObj = {
            ...reqObj,
            sessionId: res?.data?.session_id ?? reqObj?.session_id ?? "",
            modificationCount:
              res?.data?.modification_count ?? reqObj?.modification_count ?? 0,
            consolidated: true,
            type: typ,
            Protocols: reqObj?.Protocols ?? "",
            ProgressNotes: reqObj?.ProgressNotes ?? "",
            Conclusion: reqObj?.Conclusion ?? "",
          };
          if (typ === "surgery") {
            apiObj.PreSurgicalDocumentation = Array.isArray(
              reqObj?.PreSurgicalDocumentation,
            )
              ? getArryAsString(reqObj?.PreSurgicalDocumentation ?? [])
              : "";
            apiObj.IntraSurgicalDocumentation = Array.isArray(
              reqObj?.IntraSurgicalDocumentation,
            )
              ? getArryAsString(reqObj?.IntraSurgicalDocumentation ?? [])
              : "";
            apiObj.PostSurgicalDocumentation = Array.isArray(
              reqObj?.PostSurgicalDocumentation,
            )
              ? getArryAsString(reqObj?.PostSurgicalDocumentation ?? [])
              : "";
            apiObj.OwnerCommunication = Array.isArray(
              reqObj?.OwnerCommunication,
            )
              ? getArryAsString(reqObj?.OwnerCommunication ?? [])
              : "";
            apiObj.AdditionalDocumentation = Array.isArray(
              reqObj?.AdditionalDocumentation,
            )
              ? getArryAsString(reqObj?.AdditionalDocumentation ?? [])
              : "";
          }
          await onUpdateNote(apiObj);
        }
      } else {
        dispatch(
          setApiInProgress({ apiType: "consolidateSoap", inProgress: false }),
        );
        dispatch(hideLoader());
        dispatch(showLoaderText(""));
      }
    } catch (error) {
      dispatch(
        setApiInProgress({ apiType: "consolidateSoap", inProgress: false }),
      );
    }
  };

  const hasNonBooleanStatus = reqDet?.procedures?.some((procedure) =>
    procedure?.procedureDetails?.some(
      (detail) =>
        detail?.status !== "true" &&
        detail?.status !== "false" &&
        detail?.status !== "requested" &&
        detail?.status !== "rejected",
    ),
  );

  const getDischargeSummaryObject = () => {
    const outPatNotes = processGroupedNotes([
      getOutpatientNotes(
        reqDet?.inpatientNotes,
        reqDet?.appointment?.appointmentId,
      )?.find((li) => li?.consolidated) ??
        getOutpatientNotes(
          reqDet?.inpatientNotes,
          reqDet?.appointment?.appointmentId,
        )?.find((li) => !li?.consolidated) ??
        {},
    ]);
    const surgeryNotes = processGroupedNotes([
      getInpatNotes(
        reqDet?.inpatientNotes,
        reqDet?.appointment?.appointmentId,
      )?.find((li) => li?.type === "surgery" && li?.consolidated) ??
        getInpatNotes(
          reqDet?.inpatientNotes,
          reqDet?.appointment?.appointmentId,
        )?.find((li) => li?.type === "surgery" && !li?.consolidated) ??
        {},
    ]);
    const inpatNotes = processGroupedNotes([
      getInpatNotes(
        reqDet?.inpatientNotes,
        reqDet?.appointment?.appointmentId,
      )?.find((li) => li?.type === "inpatient" && li?.consolidated) ??
        getInpatNotes(
          reqDet?.inpatientNotes,
          reqDet?.appointment?.appointmentId,
        )?.find((li) => li?.type === "inpatient" && !li?.consolidated) ??
        {},
    ]);
    return {
      consolidated_soap_notes: [
        ...(outPatNotes ?? []),
        ...(inpatNotes ?? []),
        ...(surgeryNotes ?? []),
        JSON.stringify({ appt_details: getApptDetailsForSoap() }),
      ],
    };
  };

  const onFinalize = async () => {
    if (hasNonBooleanStatus) return setWarnModVsble(true);
    if (
      !appDet?.inpatient &&
      consolidateShouldBeTrueForOutpatient(
        reqDet?.clinicalNotes,
        reqDet?.appointment?.appointmentId,
      )
    ) {
      const reqList = reqDet?.clinicalNotes?.filter(
        (cn) =>
          cn?.appointmentId === reqDet?.appointment?.appointmentId &&
          !cn?.consolidated,
      );
      if (reqList?.length === 0 || reqList?.length === 1) return;
      const soap_notes = reqList?.map((obj) =>
        fieldMap
          ?.map(([k, src]) => {
            const raw = (obj[src] ?? "").toString();
            const safe = raw?.replace(/\r?\n/g, " ")?.replace(/'/g, "\\'");
            return `${k}:'${safe}'`;
          })
          ?.join(","),
      );
      const data = {
        soap_notes,
        case_type: "outpatient",
        appt_details: getApptDetailsForSoap(),
      };
      await onConsolidateSoap(data, "outpatient");
    }
    // Check if consolidation is needed
    const shouldConsolidate =
      appDet?.inpatient &&
      (consolidateShouldBeTrueForOutpatient(
        reqDet?.clinicalNotes,
        reqDet?.appointment?.appointmentId,
      ) ||
        consolidateShouldBeTrue(reqDet?.inpatientNotes, "surgery") ||
        consolidateShouldBeTrue(reqDet?.inpatientNotes, "inpatient"));

    if (shouldConsolidate) {
      if (
        consolidateShouldBeTrueForOutpatient(
          reqDet?.clinicalNotes,
          reqDet?.appointment?.appointmentId,
        )
      ) {
        const reqList = reqDet?.clinicalNotes?.filter(
          (cn) =>
            cn?.appointmentId === reqDet?.appointment?.appointmentId &&
            !cn?.consolidated,
        );
        if (reqList?.length === 0 || reqList?.length === 1) return;
        const soap_notes = reqList?.map((obj) =>
          fieldMap
            ?.map(([k, src]) => {
              const raw = (obj[src] ?? "").toString();
              const safe = raw?.replace(/\r?\n/g, " ")?.replace(/'/g, "\\'");
              return `${k}:'${safe}'`;
            })
            ?.join(","),
        );
        const data = {
          soap_notes,
          case_type: "outpatient",
          appt_details: getApptDetailsForSoap(),
        };
        dispatch(showLoader());
        await onConsolidateSoap(data, "outpatient");
        dispatch(hideLoader());
      }
      if (consolidateShouldBeTrue(reqDet?.inpatientNotes, "surgery")) {
        const reqList = reqDet?.inpatientNotes?.filter(
          (li) =>
            li?.appointmentId === reqDet?.appointment?.appointmentId &&
            li?.type?.toLowerCase() === "surgery" &&
            moment(new Date(li?.createdDate)).format("YYYY-MM-DD") ===
              moment(new Date()).format("YYYY-MM-DD") &&
            !li?.consolidated,
        );
        if (reqList?.length > 0 && reqList?.length > 1) {
          const soap_notes = reqList?.map((obj) =>
            surFieldMap
              ?.map(([k, src]) => {
                const raw = (obj[src] ?? "").toString();
                const safe = raw?.replace(/\r?\n/g, " ")?.replace(/'/g, "\\'");
                return `${k}:'${safe}'`;
              })
              ?.join(","),
          );
          const data = {
            soap_notes,
            case_type: "surgery",
            appt_details: getApptDetailsForSoap(),
          };
          dispatch(showLoader());
          await onConsolidateSoap(data, "surgery");
          dispatch(hideLoader());
        }
      }
      if (consolidateShouldBeTrue(reqDet?.inpatientNotes, "inpatient")) {
        const reqList = reqDet?.inpatientNotes?.filter(
          (li) =>
            li?.appointmentId === reqDet?.appointment?.appointmentId &&
            li?.type?.toLowerCase() === "inpatient" &&
            moment(new Date(li?.createdDate)).format("YYYY-MM-DD") ===
              moment(new Date()).format("YYYY-MM-DD") &&
            !li?.consolidated,
        );
        if (reqList?.length > 0 && reqList?.length > 1) {
          const soap_notes = reqList?.map((obj) =>
            inpatFieldMap
              ?.map(([k, src]) => {
                const raw = (obj[src] ?? "").toString();
                const safe = raw?.replace(/\r?\n/g, " ")?.replace(/'/g, "\\'");
                return `${k}:'${safe}'`;
              })
              ?.join(","),
          );
          const data = {
            soap_notes,
            case_type: "inpatient",
            appt_details: getApptDetailsForSoap(),
          };
          const combRedFlags = reqList?.map((li) => li?.redFlags)?.join(", ");
          const combInstFlags = reqList
            ?.map((li) => li?.instructionsStatus)
            ?.join(", ");
          if (combInstFlags?.length > 0) {
            data.Instructions = combInstFlags ?? "";
          }
          if (combRedFlags?.length > 0) {
            data.RedFlags = combRedFlags ?? "";
          }
          dispatch(showLoader());
          await onConsolidateSoap(data, "inpatient");
          dispatch(hideLoader());
        }
      }
    }

    // Call discharge summary after consolidation (if it ran) or directly (if consolidation was skipped)
    if (
      appDet?.inpatient &&
      (reqDet?.clinicalNotes?.filter(
        (li) => li?.appointmentId === reqDet?.appointment?.appointmentId,
      )?.length > 0 ||
        reqDet?.inpatientNotes?.filter(
          (li) => li?.appointmentId === reqDet?.appointment?.appointmentId,
        ).length > 0)
    ) {
      dispatch(showLoader());
      const res = await soapApiJson.post(
        "/generate-discharge-summary/",
        getDischargeSummaryObject(),
      );
      if (res?.status === 200) {
        if (res?.data?.discharge_summary) {
          const reqObj = toObject(res?.data?.discharge_summary);
          await onUpdateNote(reqObj);
          dispatch(hideLoader());
        }
      } else {
        dispatch(hideLoader());
      }
    }
    setIsSumamryView(false);
    setFinModVsble(true);
  };

  const onCloseRemarks = () => {
    setRemarksModVsble(false);
  };

  const getReqSoapList = () => {
    return reqDet?.appointment?.inpatient && reqDet?.inpatient?.patientId
      ? getInpatNotes(
          reqDet?.inpatientNotes,
          reqDet?.appointment?.appointmentId,
        )
      : getOutpatientNotes(
          reqDet?.clinicalNotes,
          reqDet?.appointment?.appointmentId,
        );
  };

  const onViewSummary = () => {
    setIsSumamryView(true);
    setFinModVsble(true);
  };

  const handleSelectedTab = (main, subTab) => {
    setSelectedTabs({ main, subTab });
  };

  return (
    <>
      <div className="pat-top-con light-blue-back4 ph20 pv10 mtMin20 w100Per">
        <div className="flex-row-ali-cen">
          <Typography className="fs12 blue-color font-bold">
            Case ID - {appDet?.caseId}
          </Typography>
          <Typography className="blue-color fs12 font-medium ml15">
            {appDet?.serviceType}
          </Typography>
          <Typography className="blue-color fs12 font-medium ml15">
            {moment(new Date(appDet?.appointmentDate)).format(
              "DD MMM YYYY, HH:mm",
            )}
          </Typography>
          <Typography className="blue-color fs12 font-medium ml15">
            {getRightSaluation(clinicVets, appDet?.doctorId)}
            {appDet?.doctorName}
          </Typography>
          <Typography className="black fs12 font-medium ml15">
            Last Visit{" "}
            {moment(new Date(reqDet?.lastVisitDate)).format("DD, MMM YYYY")}
          </Typography>
          {reqDet?.lastAppointmentId ? (
            <Typography
              className="blue-color fs12 txt-semi-bold ml15 underline cursor"
              onClick={handleViewSmmary}
            >
              View Summary
            </Typography>
          ) : null}
          <div className="flex1-end">
            <Typography className="fs12 blue-color font-bold">
              Est. Rs.{" "}
              {Number(
                getTotalEstCostForWorkbook(
                  procedures ?? [],
                  procedValues?.consumList ?? [],
                  procedValues?.adminList ?? [],
                  diagList ?? [],
                ) ?? 0,
              )?.toFixed(2)}
            </Typography>
            <div className="ml15">
              <CustomButton
                text="View"
                smallBtn
                onClick={handlePaymentView}
                whiteBtn
              />
            </div>
            {appDet?.appointmentStatus === "consultation" ||
            (appDet?.inpatient && appDet?.appointmentStatus === "recovery") ? (
              <div className="ml15">
                <CustomButton
                  text="Finalize"
                  smallBtn
                  onClick={onFinalize}
                  disabled={
                    isAnyApiInProgress ||
                    (appDet?.appointmentStatus !== "consultation" &&
                      !appDet?.inpatient)
                  }
                  grayBtn={
                    isAnyApiInProgress ||
                    (appDet?.appointmentStatus !== "consultation" &&
                      !appDet?.inpatient)
                  }
                />
              </div>
            ) : null}
            {appDet?.appointmentStatus?.toLowerCase() === "finalize" ||
            appDet?.appointmentStatus?.toLowerCase() === "completed" ? (
              <div className="ml20">
                <div>
                  <CustomButton
                    text="View Summary"
                    smallBtn
                    onClick={onViewSummary}
                  />
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
      <div className="flex-row w100Per mv10">
        <div className="w93Per">
          <div className="bs-margin pb10">
            <div className="flex-row">
              {tabList?.map((li) => {
                if (li?.name !== selectedTabs?.main) return null;
                return li?.list?.map((sub) => (
                  <Typography
                    className={`ml20 newTab cursor ${selectedTabs?.subTab === sub ? "newTabSelected" : ""}`}
                    onClick={() => handleSelectedTab(li?.name, sub)}
                  >
                    {sub}
                  </Typography>
                ));
              })}
            </div>
          </div>
          <div className="scroll-70vh mtMin20">
            {selectedTabs?.main === "Clinical Workflow" ? (
              selectedTabs?.subTab === "Diagnostics" ? (
                <PetDiagnostics />
              ) : selectedTabs?.subTab === "Procedures" ? (
                <PetProcedures />
              ) : selectedTabs?.subTab === "SOAP Notes" ? (
                <SoapNotesNew appointment={appointment} />
              ) : selectedTabs?.subTab === "Vitals" ? (
                <PetVitals />
              ) : null
            ) : selectedTabs?.main === "Forms" ? (
              selectedTabs?.subTab === "Protocol Forms" ? (
                <PetTreatmentPlan />
              ) : selectedTabs?.subTab === "Consent Forms" ? (
                <PetForms />
              ) : null
            ) : selectedTabs?.main === "Records" ? (
              selectedTabs?.subTab === "Body Map" ? (
                <BodyMap />
              ) : selectedTabs?.subTab === "Files" ? (
                <Files />
              ) : null
            ) : selectedTabs?.main === "Tasks" ? (
              selectedTabs?.subTab === "Tasks" ? (
                <InpatientTasks />
              ) : null
            ) : null}
          </div>
        </div>
        <div className="w7Per">
          <div className="flex1-end">
            <div
              className="bs-margin"
              style={{ height: window.innerHeight / 1.3 }}
            >
              <div className="pv10">
                <div
                  className="mt10 cursor pos-rel"
                  onClick={() =>
                    handleSelectedTab("Clinical Workflow", "Diagnostics")
                  }
                >
                  <div className="flex-center">
                    <img
                      src={require("../../../../assets/images/png/soapNotes.png")}
                      className={
                        selectedTabs?.main === "Clinical Workflow"
                          ? "wrk-img-slct"
                          : "wrk-img"
                      }
                    />
                    {getReqSoapList()?.length > 0 ? (
                      <div className="wrk-dot">
                        <Typography className="fs8 white-color font-medium">
                          {getReqSoapList()?.length}
                        </Typography>
                      </div>
                    ) : null}
                  </div>
                  <Typography className="fs10 font-medium gray4 text-align-center mt3">
                    Clinical Workflow
                  </Typography>
                </div>
                <div
                  className="mt10 cursor pos-rel"
                  onClick={() => handleSelectedTab("Forms", "Protocol Forms")}
                >
                  <div className="flex-center">
                    <img
                      src={require("../../../../assets/images/png/treatPlan.png")}
                      className={
                        selectedTabs?.main === "Forms"
                          ? "wrk-img-slct"
                          : "wrk-img"
                      }
                    />
                    {reqDet?.treatmentPlas?.length > 0 ? (
                      <div className="wrk-dot">
                        <Typography className="fs8 white-color font-medium">
                          {reqDet?.treatmentPlas?.length}
                        </Typography>
                      </div>
                    ) : null}
                  </div>
                  <Typography className="fs10 font-medium gray4 text-align-center mt3">
                    Forms
                  </Typography>
                </div>
                <div
                  className="mt10 cursor pos-rel"
                  onClick={() => handleSelectedTab("Records", "Body Map")}
                >
                  <div className="flex-center">
                    <img
                      src={require("../../../../assets/images/png/files.png")}
                      className={
                        selectedTabs?.main === "Records"
                          ? "wrk-img-slct"
                          : "wrk-img"
                      }
                    />
                    {reqDet?.files?.length > 0 ? (
                      <div className="wrk-dot">
                        <Typography className="fs8 white-color font-medium">
                          {reqDet?.files?.length}
                        </Typography>
                      </div>
                    ) : null}
                  </div>
                  <Typography className="fs10 font-medium gray4 text-align-center mt3">
                    Records
                  </Typography>
                </div>
                {appDet?.inpatient ? (
                  <div
                    className="cursor pos-rel"
                    onClick={() => handleSelectedTab("Tasks", "Tasks")}
                  >
                    <div className="flex-center">
                      <img
                        src={require("../../../../assets/images/png/tasks.png")}
                        className={
                          selectedTabs?.main === "Tasks"
                            ? "wrk-img-slct"
                            : "wrk-img"
                        }
                      />
                      {reqDet?.inpatient?.tasks?.filter(
                        (li) => li?.taskType?.toLowerCase() === "main",
                      )?.length > 0 ? (
                        <div className="wrk-dot">
                          <Typography className="fs8 white-color font-medium">
                            {
                              reqDet?.inpatient?.tasks?.filter(
                                (li) => li?.taskType?.toLowerCase() === "main",
                              )?.length
                            }
                          </Typography>
                        </div>
                      ) : null}
                    </div>
                    <Typography className="fs10 font-medium gray4 text-align-center mt3">
                      Tasks
                    </Typography>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <Grid container spacing={0}>
        <Grid item xs={12} sm={12} md={10} lg={11} xl={11}>
          <div className="scroll-80vh">
            <div className="blue-brdr-box">
              <div className="flex-row-ali-cen">
                <div className="w70Per">
                  <div className="flex-row-ali-cen">
                    <Typography className="fs14 blue-color font-bold">
                      Case ID - {appDet?.caseId}
                    </Typography>
                    <Typography className="light-blue fs14 txt-semi-bold ml10">
                      {appDet?.serviceType}
                      {appDet?.serviceType === "Consultation"
                        ? ` | ${
                            Array.isArray(appDet?.reason)
                              ? appDet?.reason?.join(", ")
                              : ""
                          }`
                        : ""}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen mt10">
                    <div className="flex-row-ali-cen">
                      <img
                        src={require("../../../../assets/images/png/calen.png")}
                        className="img-wh15"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {moment(new Date(appDet?.appointmentDate)).format(
                          "DD MMM YYYY",
                        )}
                      </Typography>
                    </div>
                    {!appDet?.inpatient ? (
                      <div className="flex-row-ali-cen ml10">
                        <img
                          src={require("../../../../assets/images/png/clock.png")}
                          className="img-wh15"
                        />
                        <Typography className="yellow2 fs14 txt-semi-bold ml5">
                          {appDet?.appointmentStartTime ??
                            moment(
                              new Date(appDet?.appointmentdateTime),
                            ).format("HH:mm")}
                        </Typography>
                      </div>
                    ) : null}
                    <div className="flex-row-ali-cen ml10">
                      <img
                        src={require("../../../../assets/images/png/steath.png")}
                        className="img-wh20"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {getRightSaluation(clinicVets, appDet?.doctorId)}
                        {appDet?.doctorName}
                      </Typography>
                    </div>
                    {appDet?.inpatient ? (
                      <>
                        <div className="flex-row-ali-cen ml10">
                          <Typography className="blue4 fs12 txt-semi-bold">
                            {reqDet?.inpatient?.facilityType?.toLowerCase() ===
                            "operationtheatre"
                              ? "Opertation Theature : "
                              : "Kennel Number : "}
                          </Typography>
                          <Typography className="gray26 fs12 txt-semi-bold ml5">
                            {reqDet?.inpatient?.kennelNumber ?? ""}
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen ml10">
                          <Typography className="blue4 fs12 txt-semi-bold">
                            Outstanding Tasks:
                          </Typography>
                          <Typography className="gray26 fs12 txt-semi-bold ml5">
                            {
                              reqDet?.inpatient?.tasks?.filter(
                                (li) => !li?.status,
                              )?.length
                            }
                          </Typography>
                        </div>
                        <div className="flex-row-ali-cen ml10">
                          <Typography className="blue4 fs12 txt-semi-bold">
                            No. of Days:
                          </Typography>
                          <Typography className="gray26 fs12 txt-semi-bold ml5">
                            {getDayOffsetNumber(appDet?.appointmentdateTime)}
                          </Typography>
                        </div>
                      </>
                    ) : null}
                  </div>
                  {!appDet?.inpatient ? (
                    <>
                      <div className="flex-row-ali-cen mt10">
                        <Typography className="card-black1 fs14 txt-semi-bold">
                          Remarks:
                        </Typography>
                        <img
                          src={require("../../../../assets/images/png/edit-new.png")}
                          alt=""
                          className="img-wh20 ml10 cursor"
                          onClick={() => setRemarksModVsble(true)}
                        />
                      </div>
                      <Typography className="black fs12 font-medium">
                        {appDet?.remarks}
                      </Typography>
                    </>
                  ) : null}
                </div>
                <div className="w30Per">
                  <div className="flex1-end">
                    <div>
                      <Typography className="black24 fs14 font-bold">
                        Estimated Cost
                      </Typography>
                      <Typography className="red15 fs10 font-medium">
                        * Does not include prescription costs
                      </Typography>
                      <div className="flex-row-ali-cen">
                        <Typography className="red15 fs26 font-bold">
                          Rs.{" "}
                          {Number(
                            getTotalEstCostForWorkbook(
                              procedures ?? [],
                              procedValues?.consumList ?? [],
                              procedValues?.adminList ?? [],
                              diagList ?? [],
                            ) ?? 0,
                          )?.toFixed(2)}
                        </Typography>
                        <div className="ml10 flex-center">
                          <VisibilityIcon
                            sx={{
                              width: 20,
                              height: 20,
                              color: AppColors.appPrimary,
                            }}
                            className="cursor"
                            onClick={handlePaymentView}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Divider className="mv10" />
              {appDet?.inpatient ? (
                <Typography className="yellow-tag white-color font-bold fs12 con-fit">
                  Under Treatment
                </Typography>
              ) : null}

              <div className="flex-row-between-align-center">
                {!appDet?.inpatient ? (
                  <div className="flex-row-ali-cen">
                    {reqDet?.lastVisitDate?.length > 0 ? (
                      <div className="flex-row-ali-cen">
                        <Typography className="fs12 blue-color txt-regular">
                          Last Visit:
                        </Typography>
                        <Typography className="ml5 fs12 gray2 font-bold">
                          {moment(new Date(reqDet?.lastVisitDate)).format(
                            "DD, MMM YYYY",
                          )}
                        </Typography>
                      </div>
                    ) : null}
                    {reqDet?.lastAppointmentId ? (
                      <Typography
                        className="blue-color fs12 txt-semi-bold ml30 underline cursor"
                        onClick={handleViewSmmary}
                      >
                        View Summary
                      </Typography>
                    ) : null}
                  </div>
                ) : null}
                <div className="flex1-end">
                  {appDet?.appointmentStatus === "consultation" ||
                  (appDet?.inpatient &&
                    appDet?.appointmentStatus === "recovery") ? (
                    <div>
                      <div>
                        <CustomButton
                          text="Finalize"
                          smallBtn
                          onClick={onFinalize}
                          disabled={
                            isAnyApiInProgress ||
                            (appDet?.appointmentStatus !== "consultation" &&
                              !appDet?.inpatient)
                          }
                          grayBtn={
                            isAnyApiInProgress ||
                            (appDet?.appointmentStatus !== "consultation" &&
                              !appDet?.inpatient)
                          }
                        />
                      </div>
                    </div>
                  ) : null}
                  {appDet?.appointmentStatus?.toLowerCase() === "finalize" ||
                  appDet?.appointmentStatus?.toLowerCase() === "completed" ? (
                    <div className="ml20">
                      <div>
                        <CustomButton
                          text="View Summary"
                          smallBtn
                          onClick={onViewSummary}
                        />
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
            {activeTab === "procedures" && <PetProcedures />}
            {activeTab === "tasks" && (
              <div>
                <div
                  className="flex-row-ali-cen cursor mt20"
                  onClick={() => handleObjOpen("tasks", !objOpen?.tasks)}
                >
                  {objOpen?.tasks ? (
                    <ArrowDropDownIcon sx={cardIcon} />
                  ) : (
                    <ArrowRightIcon sx={cardIcon} />
                  )}
                  <Typography className="font-bold fs14 blue-color">
                    Tasks
                  </Typography>
                </div>
                {objOpen?.tasks && <InpatientTasks />}
              </div>
            )}
            {activeTab === "soapNotes" && (
              <div>
                <div
                  className="flex-row-ali-cen cursor mt20"
                  onClick={() =>
                    handleObjOpen("soapNotes", !objOpen?.soapNotes)
                  }
                >
                  {objOpen?.soapNotes ? (
                    <ArrowDropDownIcon sx={cardIcon} />
                  ) : (
                    <ArrowRightIcon sx={cardIcon} />
                  )}
                  <Typography className="font-bold fs14 blue-color">
                    Soap Notes
                  </Typography>
                </div>
                {objOpen?.soapNotes && (
                  <SoapNotesNew appointment={appointment} />
                )}
              </div>
            )}
            {activeTab === "diagnostics" && (
              <div>
                <div
                  className="flex-row-ali-cen cursor mt20"
                  onClick={() =>
                    handleObjOpen("diagnostics", !objOpen?.diagnostics)
                  }
                >
                  {objOpen?.diagnostics ? (
                    <ArrowDropDownIcon sx={cardIcon} />
                  ) : (
                    <ArrowRightIcon sx={cardIcon} />
                  )}
                  <Typography className="font-bold fs14 blue-color">
                    Diagnostics
                  </Typography>
                </div>
                {objOpen?.diagnostics && <PetDiagnostics />}
              </div>
            )}
            {activeTab === "treatmentPlan" && (
              <div>
                <div
                  className="flex-row-ali-cen cursor mt20"
                  onClick={() =>
                    handleObjOpen("treatmentPlan", !objOpen?.treatmentPlan)
                  }
                >
                  {objOpen?.treatmentPlan ? (
                    <ArrowDropDownIcon sx={cardIcon} />
                  ) : (
                    <ArrowRightIcon sx={cardIcon} />
                  )}
                  <Typography className="font-bold fs14 blue-color">
                    Protocol Forms
                  </Typography>
                </div>
                {objOpen?.treatmentPlan && <PetTreatmentPlan />}
              </div>
            )}
            {activeTab === "forms" && (
              <div>
                <div
                  className="flex-row-ali-cen cursor mt20"
                  onClick={() => handleObjOpen("forms", !objOpen?.forms)}
                >
                  {objOpen?.forms ? (
                    <ArrowDropDownIcon sx={cardIcon} />
                  ) : (
                    <ArrowRightIcon sx={cardIcon} />
                  )}
                  <Typography className="font-bold fs14 blue-color">
                    Consent Forms
                  </Typography>
                </div>
                {objOpen?.forms ? <PetForms /> : null}
              </div>
            )}
            {activeTab === "vitals" && (
              <div>
                <div
                  className="flex-row-ali-cen cursor mt20"
                  onClick={() => handleObjOpen("vitals", !objOpen?.vitals)}
                >
                  {objOpen?.vitals ? (
                    <ArrowDropDownIcon sx={cardIcon} />
                  ) : (
                    <ArrowRightIcon sx={cardIcon} />
                  )}
                  <Typography className="font-bold fs14 blue-color">
                    Vitals
                  </Typography>
                </div>
                {objOpen?.vitals ? <PetVitals /> : null}
              </div>
            )}
            {activeTab === "bodymap" && (
              <div>
                <div
                  className="flex-row-ali-cen cursor mt20"
                  onClick={() => handleObjOpen("bodymap", !objOpen?.bodymap)}
                >
                  {objOpen?.bodymap ? (
                    <ArrowDropDownIcon sx={cardIcon} />
                  ) : (
                    <ArrowRightIcon sx={cardIcon} />
                  )}
                  <Typography className="font-bold fs14 blue-color">
                    Body Map
                  </Typography>
                </div>
                {objOpen?.bodymap ? <BodyMap /> : null}
              </div>
            )}
            {activeTab === "files" && (
              <div>
                <div
                  className="flex-row-ali-cen cursor mt20"
                  onClick={() => handleObjOpen("files", !objOpen?.files)}
                >
                  {objOpen?.files ? (
                    <ArrowDropDownIcon sx={cardIcon} />
                  ) : (
                    <ArrowRightIcon sx={cardIcon} />
                  )}
                  <Typography className="font-bold fs14 blue-color">
                    Files
                  </Typography>
                </div>
                {objOpen?.files ? <Files /> : null}
              </div>
            )}
          </div>
        </Grid>
        <Grid item xs={12} sm={12} md={2} lg={1} xl={1}>
          <div className="flex1-end">
            <div className="scroll-80vh common-pb-50 pv10">
              {appDet?.inpatient ? (
                <div
                  className="cursor pos-rel"
                  onClick={() => handleActive("tasks")}
                >
                  <div className="flex-center">
                    <img
                      src={require("../../../../assets/images/png/tasks.png")}
                      className={
                        activeTab === "tasks" ? "wrk-img-slct" : "wrk-img"
                      }
                    />
                    {reqDet?.inpatient?.tasks?.filter(
                      (li) => li?.taskType?.toLowerCase() === "main",
                    )?.length > 0 ? (
                      <div className="wrk-dot">
                        <Typography className="fs8 white-color font-medium">
                          {
                            reqDet?.inpatient?.tasks?.filter(
                              (li) => li?.taskType?.toLowerCase() === "main",
                            )?.length
                          }
                        </Typography>
                      </div>
                    ) : null}
                  </div>
                  <Typography className="fs10 font-medium gray4 text-align-center mt3">
                    Tasks
                  </Typography>
                </div>
              ) : null}
              <div
                className={`cursor pos-rel ${appDet?.inpatient ? "mt10" : ""}`}
                onClick={() => handleActive("procedures")}
              >
                <div className="flex-center">
                  <img
                    src={require("../../../../assets/images/png/forms.png")}
                    className={
                      activeTab === "procedures" ? "wrk-img-slct" : "wrk-img"
                    }
                  />
                  {reqDet?.procedures?.length > 0 ? (
                    <div className="wrk-dot">
                      <Typography className="fs8 white-color font-medium">
                        {reqDet?.procedures?.length}
                      </Typography>
                    </div>
                  ) : null}
                </div>
                <Typography className="fs10 font-medium gray4 text-align-center mt3">
                  Procedures
                </Typography>
              </div>
              <div
                className="mt10 cursor pos-rel"
                onClick={() => handleActive("soapNotes")}
              >
                <div className="flex-center">
                  <img
                    src={require("../../../../assets/images/png/soapNotes.png")}
                    className={
                      activeTab === "soapNotes" ? "wrk-img-slct" : "wrk-img"
                    }
                  />
                  {getReqSoapList()?.length > 0 ? (
                    <div className="wrk-dot">
                      <Typography className="fs8 white-color font-medium">
                        {getReqSoapList()?.length}
                      </Typography>
                    </div>
                  ) : null}
                </div>
                <Typography className="fs10 font-medium gray4 text-align-center mt3">
                  Soap notes
                </Typography>
              </div>
              <div
                className="mt10 cursor pos-rel"
                onClick={() => handleActive("diagnostics")}
              >
                <div className="flex-center">
                  <img
                    src={require("../../../../assets/images/png/diagnostics.png")}
                    className={
                      activeTab === "diagnostics" ? "wrk-img-slct" : "wrk-img"
                    }
                  />
                  {reqDet?.diagnostics?.filter(
                    (li) =>
                      li?.dueDate === reqDet?.appointment?.appointmentDate &&
                      li?.appoinment?.appointmentId ===
                        reqDet?.appointment?.appointmentId,
                  )?.length > 0 ? (
                    <div className="wrk-dot">
                      <Typography className="fs8 white-color font-medium">
                        {
                          reqDet?.diagnostics?.filter(
                            (li) =>
                              li?.dueDate ===
                                reqDet?.appointment?.appointmentDate &&
                              li?.appoinment?.appointmentId ===
                                reqDet?.appointment?.appointmentId,
                          )?.length
                        }
                      </Typography>
                    </div>
                  ) : null}
                </div>
                <Typography className="fs10 font-medium gray4 text-align-center mt3">
                  Diagnostics
                </Typography>
              </div>
              <div
                className="mt10 cursor pos-rel"
                onClick={() => handleActive("treatmentPlan")}
              >
                <div className="flex-center">
                  <img
                    src={require("../../../../assets/images/png/treatPlan.png")}
                    className={
                      activeTab === "treatmentPlan" ? "wrk-img-slct" : "wrk-img"
                    }
                  />
                  {reqDet?.treatmentPlas?.length > 0 ? (
                    <div className="wrk-dot">
                      <Typography className="fs8 white-color font-medium">
                        {reqDet?.treatmentPlas?.length}
                      </Typography>
                    </div>
                  ) : null}
                </div>
                <Typography className="fs10 font-medium gray4 text-align-center mt3">
                  Protocol Forms
                </Typography>
              </div>
              <div
                className="mt10 cursor pos-rel"
                onClick={() => handleActive("forms")}
              >
                <div className="flex-center">
                  <img
                    src={require("../../../../assets/images/png/forms.png")}
                    className={
                      activeTab === "forms" ? "wrk-img-slct" : "wrk-img"
                    }
                  />
                  {reqDet?.forms?.length > 0 ? (
                    <div className="wrk-dot">
                      <Typography className="fs8 white-color font-medium">
                        {reqDet?.forms?.length}
                      </Typography>
                    </div>
                  ) : null}
                </div>
                <Typography className="fs10 font-medium gray4 text-align-center mt3">
                  Consent Forms
                </Typography>
              </div>
              <div
                className="mt10 cursor pos-rel"
                onClick={() => handleActive("vitals")}
              >
                <div className="flex-center">
                  <img
                    src={require("../../../../assets/images/png/vitals.png")}
                    className={
                      activeTab === "vitals" ? "wrk-img-slct" : "wrk-img"
                    }
                  />
                  {reqDet?.vitals?.length > 0 ? (
                    <div className="wrk-dot">
                      <Typography className="fs8 white-color font-medium">
                        {reqDet?.vitals?.length}
                      </Typography>
                    </div>
                  ) : null}
                </div>
                <Typography className="fs10 font-medium gray4 text-align-center mt3">
                  Vitals
                </Typography>
              </div>
              <div
                className="mt10 cursor pos-rel"
                onClick={() => handleActive("bodymap")}
              >
                <div className="flex-center">
                  <img
                    src={require("../../../../assets/images/png/bodyMap.png")}
                    className={
                      activeTab === "bodymap" ? "wrk-img-slct" : "wrk-img"
                    }
                  />
                  {reqDet?.bodymaps?.length > 0 ? (
                    <div className="wrk-dot">
                      <Typography className="fs8 white-color font-medium">
                        {reqDet?.bodymaps?.length}
                      </Typography>
                    </div>
                  ) : null}
                </div>
                <Typography className="fs10 font-medium gray4 text-align-center mt3">
                  Body Map
                </Typography>
              </div>
              <div
                className="mt10 cursor pos-rel"
                onClick={() => handleActive("files")}
              >
                <div className="flex-center">
                  <img
                    src={require("../../../../assets/images/png/files.png")}
                    className={
                      activeTab === "files" ? "wrk-img-slct" : "wrk-img"
                    }
                  />
                  {reqDet?.files?.length > 0 ? (
                    <div className="wrk-dot">
                      <Typography className="fs8 white-color font-medium">
                        {reqDet?.files?.length}
                      </Typography>
                    </div>
                  ) : null}
                </div>
                <Typography className="fs10 font-medium gray4 text-align-center mt3">
                  Files
                </Typography>
              </div>
            </div>
          </div>
        </Grid>
      </Grid> */}

      {remarksModVsble ? (
        <UpdateRemarks
          remarksModVsble={remarksModVsble}
          onCloseRemarks={onCloseRemarks}
          remarks={appDet?.remarks}
          notes={appDet?.notes}
          id={appDet?.appointmentId}
        />
      ) : null}
      {finModVsble ? (
        <WorkBookHistory
          finModVsble={finModVsble}
          setFinModVsble={setFinModVsble}
          handleFinalize={handleFinalize}
          isSumamryView={isSumamryView}
        />
      ) : null}

      <CustomModal
        open={warnModVsble}
        onClose={() => setWarnModVsble(false)}
        header=""
        modal
        modalWidth={30}
        headerShown={false}
      >
        <div className="flex-row">
          <Typography className="txt-semi-bold fs16 text-align-center mv20 orange4">
            Please ensure to update the status for all the records
          </Typography>
          <div className="flex1-end mtMin75">
            <IconButton
              aria-label="close"
              onClick={() => setWarnModVsble(false)}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={summaryModVsble}
        onClose={() => setSummaryModVsble(false)}
        header=""
        headerCenter
        headerBold
        modal
        modalWidth={80}
      >
        <div className="scroll-80vh">
          <div className="his-bodr">
            <div className="flex-row-ali-cen mv20">
              <div className="w20Per">
                <div className="pl20">
                  <div>
                    {clinicDet?.image ? (
                      <img src={clinicDet?.image} className="img-h75" alt="" />
                    ) : (
                      <div className="flex-center h50img">
                        <Typography className="font-bold fs30 white-color capitalize">
                          {clinicDet?.name?.[0]}
                        </Typography>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="w60Per flex-center">
                <div className="font-bold fs20 blue-color">Medical Record</div>
              </div>
              <div className="w20Per flex1-end">
                <div className="pr10">
                  <img
                    src={require("../../../../assets/images/png/VetInstantLogo.png")}
                    alt=""
                    className="wh50 blu-back p5"
                  />
                </div>
              </div>
            </div>
            <div className="mh20 mb20">
              <div className="flex-row-ali-cen">
                <div className="w70Per">
                  <div className="flex-row-ali-cen">
                    <Typography className="fs14 blue-color font-bold">
                      Case ID - {lastSummary?.appointment?.caseId}
                    </Typography>
                    <Typography className="light-blue fs14 txt-semi-bold ml10">
                      {lastSummary?.appointment?.serviceType} |{" "}
                      {lastSummary?.appointment?.reason}
                    </Typography>
                  </div>
                  <div className="flex-row-ali-cen mt10">
                    <div className="flex-row-ali-cen">
                      <img
                        src={require("../../../../assets/images/png/calen.png")}
                        className="img-wh15"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {moment(
                          new Date(lastSummary?.appointment?.appointmentDate),
                        ).format("DD MMM YYYY")}
                      </Typography>
                    </div>
                    <div className="flex-row-ali-cen ml10">
                      <img
                        src={require("../../../../assets/images/png/clock.png")}
                        className="img-wh15"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {lastSummary?.appointment?.appointmentStartTime ??
                          moment(
                            new Date(
                              lastSummary?.appointment?.appointmentdateTime,
                            ),
                          ).format("HH:mm")}
                      </Typography>
                    </div>
                    <div className="flex-row-ali-cen ml10">
                      <img
                        src={require("../../../../assets/images/png/steath.png")}
                        className="img-wh20"
                      />
                      <Typography className="yellow2 fs14 txt-semi-bold ml5">
                        {getRightSaluation(
                          clinicVets,
                          lastSummary?.appointment?.doctorId,
                        )}
                        {/* {lastSummary?.appointment?.hospitalId ===
                        lastSummary?.appointment?.doctorId
                          ? ""
                          : "Dr. "} */}
                        {lastSummary?.appointment?.doctorName}
                      </Typography>
                    </div>
                  </div>
                </div>
              </div>
              <div className="gry-hor-split mv15" />
              {lastSummary?.clinicalNotes?.find(
                (cn) =>
                  cn?.appointmentId === lastSummary?.appointment?.appointmentId,
              )?.conclusion?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold">
                    Overview
                  </Typography>

                  <Typography className="fs12 txt-regular gray11">
                    {
                      lastSummary?.clinicalNotes?.find(
                        (cn) =>
                          cn?.appointmentId ===
                          lastSummary?.appointment?.appointmentId,
                      )?.conclusion
                    }
                  </Typography>
                </>
              ) : null}
              {lastSummary?.prevetive?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Preventive
                  </Typography>

                  <PreventiveView preventives={lastSummary?.prevetive} />
                </>
              ) : null}
              {lastSummary?.diagnostics?.filter(
                (li) => li?.status?.toLowerCase() === "completed",
              ) > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Diagnostics
                  </Typography>
                  <DiagnosticsView diagnostics={lastSummary?.diagnostics} />
                </>
              ) : null}
              {lastSummary?.prescription?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Prescription
                  </Typography>
                  <PrescriptionView prescriptions={lastSummary?.prescription} />
                </>
              ) : null}
              {lastSummary?.clinicalNotes?.find(
                (cn) =>
                  cn?.appointmentId === lastSummary?.appointment?.appointmentId,
              ) ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Soap Notes
                  </Typography>

                  <SoapNoteView
                    apntId={lastSummary?.appointment?.appointmentId}
                    soapNote={lastSummary?.clinicalNotes?.find(
                      (cn) =>
                        cn?.appointmentId ===
                        lastSummary?.appointment?.appointmentId,
                    )}
                  />
                </>
              ) : null}
              {lastSummary?.treatmentPlas?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Protocol Forms
                  </Typography>
                  <TreatmentPlanView plans={lastSummary?.treatmentPlas} />
                </>
              ) : null}
              {lastSummary?.forms?.filter((li) => li?.status)?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Consent Forms
                  </Typography>
                  <FormsView
                    forms={lastSummary?.forms?.filter((li) => li?.status)}
                  />
                </>
              ) : null}
              {lastSummary?.vitals?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Vitals
                  </Typography>
                  <VitalsView vitals={lastSummary?.vitals} />
                </>
              ) : null}
              {lastSummary?.bodymaps?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Body Map
                  </Typography>
                  <BodyMapView bodyMaps={lastSummary?.bodymaps} />
                </>
              ) : null}
              {lastSummary?.files?.length > 0 ? (
                <>
                  <Typography className="fs14 blue-color font-bold mt10">
                    Files
                  </Typography>
                  <FileView files={lastSummary?.files} />
                </>
              ) : null}
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default PatientWorkbook;
